'use client'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'

import { HelpDrawer } from '../HelpDrawer'

import {
  AccountDrawer,
  AppPickerDrawer,
  MobileMenuAccountSection,
  MobileMenuFooter,
  MobileMenuHeader,
  MobileMenuNavigation,
  ProjectPickerDrawer,
  ProjectsView,
  WorkspacesView,
} from './components'
import { useMobileMenuContext } from './context'

import styles from './MobileMenu.module.scss'

export function BaseMobileMenuView() {
  const {
    auth0User,
    contentRef,
    helpItems,
    isModulesMenu,
    isOpen,
    onClose,
    renderHeader,
    showProjectSelector,
    showWorkspaceSelector,
    viewClassName,
  } = useMobileMenuContext()

  return (
    <>
      {isOpen ? <div className={styles.overlay} onClick={() => onClose()} aria-hidden="true" /> : null}

      <div
        className={`${styles.drawer} ${isOpen ? styles.open : ''} ${isModulesMenu ? styles.modulesDrawer : ''}`}
        data-testid={MOBILE_MENU_TEST_IDS.root}
      >
        <div className={`${styles.viewsContainer} ${styles[viewClassName]}`}>
          <div className={styles.menuView}>
            {renderHeader ? renderHeader() : <MobileMenuHeader />}

            <div ref={contentRef} className={styles.content}>
              {auth0User ? <MobileMenuAccountSection /> : null}
              <MobileMenuNavigation />
            </div>

            {auth0User && showWorkspaceSelector ? <MobileMenuFooter /> : null}
          </div>

          {showProjectSelector ? <ProjectsView /> : null}
          {showWorkspaceSelector ? <WorkspacesView /> : null}
        </div>
      </div>

      <AppPickerDrawer />
      {showProjectSelector ? <ProjectPickerDrawer /> : null}
      {auth0User ? <AccountDrawer /> : null}
      {helpItems && helpItems.length > 0 ? <HelpDrawerHost /> : null}
    </>
  )
}

function HelpDrawerHost() {
  const { helpItems, isHelpDrawerOpen, onClose, onHelpClick, setIsHelpDrawerOpen } = useMobileMenuContext()

  if (!helpItems?.length) {
    return null
  }

  return (
    <HelpDrawer
      isOpen={isHelpDrawerOpen}
      onClose={() => setIsHelpDrawerOpen(false)}
      items={helpItems}
      onItemClick={(itemId: string) => {
        onHelpClick?.(itemId)
        onClose()
      }}
    />
  )
}
